export default "__VITE_ASSET__BC_2KkDd__"